import React from 'react'
import { IIntakeStep } from './IIntakeStep'
import { IntakeStepButton } from './IntakeStepButton'
import { ANSWER_INDEX, ReviewStepRadioButtons } from './ReviewStepRadioButtons'

/* tslint:disable */
export const review1Steps: IIntakeStep[] = [
  {
    Component: IntakeStepButton, buttonLabel: 'Start', children: <div>
    In order to ensure that the WebTIPS site is effective in teaching you everything you need to know about preparing for your child's surgery, we'd like to ask you a few questions about the section you just read. Just click the answer you think is correct!
      <br /><br />
    Once you've answered the questions, you'll be able to move on to the next section.
      </div>,
    completed: intake => !!intake.review1CheckedDescribeText,
    label: 'Home before surgery review',
    name: 'review1CheckedDescribeText',
  },
  {
    Component: ReviewStepRadioButtons, completed: intake => !!intake.review1PrepMorningSurgery,
    label: 'What are 2 important things you can do as a parent to prepare yourself for the morning of surgery?',
    name: 'review1PrepMorningSurgery',
    correctText: 'Right answer.',
    wrongText: 'The correct answer was A.',
    crossOutIndexes: [
      ANSWER_INDEX.B,
      ANSWER_INDEX.C,
      ANSWER_INDEX.D,
    ],
    options: [{
      correct: true,
      label: 'A: Get a good night\'s sleep and get up a few minutes earlier in the morning to eat a good breakfast',
      value: 'sleepEarly',
    }, {
      correct: false,
      hideAfterAnswer: true,
      label: 'B: Stay up late and forget to eat breakfast',
      value: 'lateForget',
    }, {
      correct: false,
      hideAfterAnswer: true,
      label: 'C: Get a good night\'s sleep and get up a few minutes earlier in the morning to feed your child breakfast',
      value: 'feedChild',
    }, {
      correct: false,
      hideAfterAnswer: true,
      label: 'D: Plan to run errands on the way to the hospital',
      value: 'runErrands',
    }],
  },
  {
    Component: ReviewStepRadioButtons, completed: intake => !!intake.review1DeepBreathingExcept,
    correctText: 'Right answer. The other statements are all true',
    wrongText: 'The correct answer was C. The other statements are all true',
    crossOutIndexes: [
      ANSWER_INDEX.C
    ],
    label: 'All of the following are true about deep breathing except:', name: 'review1DeepBreathingExcept', options: [{
      correct: false,
      label: 'A: Deep breathing means taking deep breaths from your diaphragm instead of shallow breaths from your chest.',
      hideAfterAnswer: false,
      value: 'deep',
    }, {
      correct: false,
      label: 'B: Deep breathing helps you feel calm and relaxed.',
      hideAfterAnswer: false,
      value: 'calm',
    }, {
      correct: true,
      label: 'C: To practice deep breathing, lie on your back with your hands behind your head.',
      hideAfterAnswer: true,
      value: 'backHandsBehindBack',
    }, {
      correct: false,
      hideAfterAnswer: false,
      label: 'D: To practice deep breathing, sit up straight with one hand on your chest and one hand on your stomach.',
      value: 'sitStraight',
    }],
  },
  {
    Component: ReviewStepRadioButtons, completed: intake => !!intake.review1GuidedImageryExcept,
    correctText: 'Right answer. The other statements are all true.',
    wrongText: 'The correct answer was C. The other statements are all true.',
    crossOutIndexes: [
      ANSWER_INDEX.C,
    ],
    label: 'All of the following are true about guided imagery except:', name: 'review1GuidedImageryExcept', options: [{
      correct: false,
      hideAfterAnswer: false,
      label: 'A: Guided imagery is the practice of using imagination to focus your attention.',
      value: 'imagination',
    }, {
      correct: false,
      hideAfterAnswer: false,
      label: 'B: Guided imagery helps you feel calm and relaxed.',
      value: 'calm',
    }, {
      correct: true,
      hideAfterAnswer: true,
      label: 'C: Practice guided imagery no more than once or twice before your child’s surgery.',
      value: 'noMore',
    }, {
      correct: false,
      hideAfterAnswer: false,
      label: 'D: To practice guided imagery, sit or lie down somewhere comfortable without too many distractions.',
      value: 'comfortable',
    }],
  },
  {
    Component: ReviewStepRadioButtons, completed: intake => !!intake.review1InductionOfAnesthesia,
    correctText: 'Right answer.',
    wrongText: 'The correct answer was B.',
    crossOutIndexes: [
      ANSWER_INDEX.A,
      ANSWER_INDEX.C,
      ANSWER_INDEX.D,
    ],
    label: 'What is induction of anesthesia?', name: 'review1InductionOfAnesthesia', options: [{
      correct: false,
      hideAfterAnswer: true,
      label: 'A: Waking up from anesthesia at the end of surgery.',
      value: 'waking',
    }, {
      correct: true,
      hideAfterAnswer: false,
      label: 'B: The process of breathing air to go to sleep before surgery.',
      value: 'breathing',
    }, {
      correct: false,
      hideAfterAnswer: true,
      label: 'C: Giving your child a pill to go to sleep before surgery.',
      value: 'pill',
    }, {
      correct: false,
      hideAfterAnswer: true,
      label: 'D: Patting your head and rubbing your stomach at the same time.',
      value: 'pattingRubbing',
    }],
  },
  {
    Component: ReviewStepRadioButtons, completed: intake => !!intake.review1AnesthesiaMaskExcept,
    correctText: 'Right answer.',
    wrongText: 'The correct answer was D.',
    label: 'All of the following are steps of practicing with the anesthesia mask with your child at home except:',
    crossOutIndexes: [
      ANSWER_INDEX.A,
      ANSWER_INDEX.B,
      ANSWER_INDEX.C,
    ],
    name: 'review1AnesthesiaMaskExcept', options: [{
      hideAfterAnswer: true,
      correct: false,
      label: 'A: Let your child play with the anesthesia mask and explain its purpose.',
      value: 'playMask',
    }, {
      hideAfterAnswer: true,
      correct: false,
      label: 'B: When your child is ready, allow them to hold the mask to their own face.',
      value: 'maskOwn',
    }, {
      hideAfterAnswer: true,
      correct: false,
      label: 'C: Encourage your child to breathe slowly through the mask.',
      value: 'breatheSlowly',
    }, {
      hideAfterAnswer: true,
      correct: true,
      label: 'D: Never put the anesthesia mask on yourself or a stuffed animal.',
      value: 'neverSelfOrStuffed',
    }],
  },
]



// WEBPACK FOOTER //
// ./src/organisms/Intakes/review1Steps.tsx